
import { MapTo } from '@adobe/aem-react-editable-components';
import MitekAgreement, { MitekAgreementEditConfig } from './MitekAgreement';

export default MapTo('cob-corp-acquisition/components/creditonebank/mitek-agreement')(MitekAgreement, MitekAgreementEditConfig);
        